import { render, staticRenderFns } from "./CianElementConfigurableScaleTableColumn.vue?vue&type=template&id=5538521e&scoped=true"
import script from "./CianElementConfigurableScaleTableColumn.vue?vue&type=script&lang=js"
export * from "./CianElementConfigurableScaleTableColumn.vue?vue&type=script&lang=js"
import style0 from "./CianElementConfigurableScaleTableColumn.vue?vue&type=style&index=0&id=5538521e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5538521e",
  null
  
)

export default component.exports